// Support Dev Filter Configuration
// This file defines which fields should be available for filtering in the Support Dev page

export const SUPPORT_DEV_FILTER_CONFIG = {
  // Fields that should be available for filtering
  filterableFields: [
   
    {
      key: "type",
      label: "Type",
      type: "select",
      filterable: true,
      order: 2,
      description: "Filter by ticket type"
    },
    {
      key: "module",
      label: "Module",
      type: "select",
      filterable: true,
      order: 3,
      description: "Filter by module"
    },
    {
      key: "category",
      label: "Category",
      type: "autocomplete",
      filterable: true,
      order: 4,
      description: "Filter by category"
    },

    {
      key: "priority",
      label: "Priority",
      type: "select",
      filterable: true,
      order: 6,
      description: "Filter by priority level"
    },
    {
      key: "developmentStatus",
      label: "Development Status",
      type: "select",
      filterable: true,
      order: 7,
      description: "Filter by development status"
    },
    {
      key: "assignTo",
      label: "Assign To",
      type: "select",
      filterable: true,
      order: 8,
      description: "Filter by assigned team member"
    },
    {
      key: "asanaLink",
      label: "Asana Link",
      type: "text",
      filterable: false, // Text fields are typically not good for filtering
      order: 9,
      description: "Asana link (not filterable)"
    },
    {
      key: "estimationTime",
      label: "Estimation Time",
      type: "text",
      filterable: false,
      order: 10,
      description: "Estimation time (not filterable)"
    },
    {
      key: "deployedDate",
      label: "Deployed Date",
      type: "date",
      filterable: true,
      order: 11,
      description: "Filter by deployment date"
    },
    {
      key: "description",
      label: "Description",
      type: "textarea",
      filterable: false,
      order: 12,
      description: "Description (not filterable)"
    },
    {
      key: "comment",
      label: "Comment",
      type: "textarea",
      filterable: false,
      order: 13,
      description: "Comment (not filterable)"
    }
  ],

  // Default filter values
  defaultFilterValues: {
    ticketStatus: "",
    type: "",
    module: "",
    category: "",
    subCategory: "",
    priority: "",
    developmentStatus: "",
    assignTo: "",
    deployedDate: ""
  },

  // Filter display settings
  filterDisplay: {
    showFilterSection: true,
    filterSectionTitle: "Filter Tickets",
    clearButtonText: "Clear",
    applyButtonText: "Apply Filters",
    showApplyButton: false, // Set to true if you want a separate apply button
    autoApply: true, // Automatically apply filters when values change
    maxVisibleFilters: 6, // Maximum number of filters to show by default
    collapsible: true, // Allow filter section to be collapsed
    defaultCollapsed: false // Start with filters expanded
  },

  // Filter validation rules
  validation: {
    requiredFields: [], // Fields that must have a value when filtering
    dateRangeValidation: true, // Enable date range validation
    minDateRange: 30, // Minimum days between start and end date (if applicable)
    maxDateRange: 365 // Maximum days between start and end date (if applicable)
  },

  // Filter performance settings
  performance: {
    debounceDelay: 300, // Delay in ms before applying text-based filters
    maxFilterOptions: 100, // Maximum number of options to show in dropdowns
    enableSearchInDropdowns: true, // Enable search within dropdown options
    cacheFilterResults: true, // Cache filter results for better performance
    cacheExpiry: 5 * 60 * 1000 // Cache expiry time in milliseconds (5 minutes)
  },

  // Filter styling and layout
  styling: {
    filterCardStyle: {
      marginBottom: 24,
      boxShadow: '0 2px 8px rgba(33, 150, 243, 0.07)'
    },
    filterGridSpacing: 3,
    filterLabelStyle: {
      fontWeight: 500,
      color: '#1976d2'
    },
    filterFieldStyle: {
      width: '100%'
    }
  }
};

// Helper function to get only filterable fields
export const getFilterableFields = () => {
  return SUPPORT_DEV_FILTER_CONFIG.filterableFields.filter(field => field.filterable);
};

// Helper function to get filterable fields sorted by order
export const getOrderedFilterableFields = () => {
  return getFilterableFields().sort((a, b) => a.order - b.order);
};

// Helper function to get field configuration by key
export const getFieldConfig = (fieldKey) => {
  return SUPPORT_DEV_FILTER_CONFIG.filterableFields.find(field => field.key === fieldKey);
};

// Helper function to check if a field is filterable
export const isFieldFilterable = (fieldKey) => {
  const field = getFieldConfig(fieldKey);
  return field ? field.filterable : false;
};

// Helper function to get default filter values
export const getDefaultFilterValues = () => {
  return { ...SUPPORT_DEV_FILTER_CONFIG.defaultFilterValues };
};

// Helper function to validate filter values
export const validateFilterValues = (filterValues) => {
  const errors = {};
  const { requiredFields } = SUPPORT_DEV_FILTER_CONFIG.validation;
  
  requiredFields.forEach(fieldKey => {
    if (!filterValues[fieldKey] || filterValues[fieldKey].trim() === '') {
      errors[fieldKey] = 'This field is required';
    }
  });
  
  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

// Export the main configuration
export default SUPPORT_DEV_FILTER_CONFIG; 